var _defs, _path, _path2, _rect, _path3, _path4, _path5, _polyline, _polyline2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a49710da-41d5-4d47-81b3-2eae9b402e77",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b910402c-5472-4073-802e-711eb38e861f,.ebfa928c-a8c9-4ae5-91a6-c42a8cc2341f{fill:none;}.b2a1cd54-5423-4ea0-8e21-267d63a7650e,.ebfa928c-a8c9-4ae5-91a6-c42a8cc2341f{stroke:#8e8e8e;}.b2a1cd54-5423-4ea0-8e21-267d63a7650e,.b910402c-5472-4073-802e-711eb38e861f,.ebfa928c-a8c9-4ae5-91a6-c42a8cc2341f{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b2a1cd54-5423-4ea0-8e21-267d63a7650e,.b861cd4d-95a8-4549-9c40-a11afebf89ed{fill:#8c5fd7;}.f8dbedaa-d0d0-494f-885b-0533be7f7cff{fill:#fff;}.b910402c-5472-4073-802e-711eb38e861f{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "png") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ebfa928c-a8c9-4ae5-91a6-c42a8cc2341f",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b2a1cd54-5423-4ea0-8e21-267d63a7650e",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b861cd4d-95a8-4549-9c40-a11afebf89ed",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f8dbedaa-d0d0-494f-885b-0533be7f7cff",
    d: "M42.2,62.3h2.5a4.4,4.4,0,0,1,2.8.8,2.9,2.9,0,0,1,.9,2.1,3.3,3.3,0,0,1-.8,2.2,4.3,4.3,0,0,1-3.1,1.1h-1v4H42.2Zm1.3,4.9h1c1.6,0,2.6-.7,2.6-2.1s-1-2-2.4-2H43.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f8dbedaa-d0d0-494f-885b-0533be7f7cff",
    d: "M50.1,72.3V62.2h1.5l3.2,5.1,1.8,3.3h0c-.1-1.3-.1-2.6-.1-4.1V62.2h1.2V72.3H56.4l-3.2-5.1a29,29,0,0,1-1.9-3.4h0c0,1.3.1,2.5.1,4.2v4.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f8dbedaa-d0d0-494f-885b-0533be7f7cff",
    d: "M67.7,71.9a10.4,10.4,0,0,1-3.1.5,5.3,5.3,0,0,1-3.8-1.3,5.1,5.1,0,0,1-1.4-3.8c0-3,2.1-5.2,5.5-5.2a6.8,6.8,0,0,1,2.5.5l-.3,1a6.8,6.8,0,0,0-2.3-.4,3.8,3.8,0,0,0-4,4.1,3.7,3.7,0,0,0,3.9,4l1.7-.2v-3h-2V67h3.3Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b910402c-5472-4073-802e-711eb38e861f",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b910402c-5472-4073-802e-711eb38e861f",
    points: "31.1 53.5 42.7 41.9 53.9 53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b910402c-5472-4073-802e-711eb38e861f",
    x1: 48,
    y1: 47.1,
    x2: 62.6,
    y2: 32.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b910402c-5472-4073-802e-711eb38e861f",
    cx: 48,
    cy: 33.8,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.6f0df4703f01485d1130cceb9b8f4e72.svg";
export { ForwardRef as ReactComponent };